module.exports = __webpack_public_path__ + "img/telecine.fe6d633a.png";